var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-management"},[_c('cl-sb',{ref:"child",attrs:{"declareType":2,"vehicleType":4}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/vue-loader@13.7.3_babel-cor_8359de338cb72d4a5c3f1d20841d7b1b/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3de58209","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.pnpm/vue-loader@13.7.3_babel-cor_8359de338cb72d4a5c3f1d20841d7b1b/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/sbgl/lswxpsb.vue
// module id = null
// module chunks = 